import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HostsRoutingModule } from './hosts-routing.module';
import { HostsComponent } from 'src/app/components/hosts/hosts.component';
import { HostRatePipe } from 'src/app/host-rate.pipe';
import { LanguagePipe } from 'src/app/language.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreditCardModule } from '../credit-card/credit-card.module';
import { ShopFromComponent } from 'src/app/components/shop-from/shop-from.component';
import { SharedModule } from '../shared/shared.module';
import { ShipmentDetailsNoHostComponent } from 'src/app/components/shipment-details-nohost/shipment-details-nohost.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { ShipmentDetailsNoHostMiddleComponent } from 'src/app/components/shipment-details-nohost-middle/shipment-details-nohost-middle.component';
@NgModule({
  declarations: [
    HostsComponent,
    HostRatePipe,
    LanguagePipe,
    ShopFromComponent,
    ShipmentDetailsNoHostComponent,
    ShipmentDetailsNoHostMiddleComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HostsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CreditCardModule,
    NgxPayPalModule,
    MatFormFieldModule,
    MatIconModule,
    MatRadioModule,
    MatButtonModule
    
  ]
})
export class HostsModule { }
